import React, { useState } from 'react';
import styled, { StyleSheetManager } from 'styled-components';
import { Typography } from '@material-ui/core';
import { colors } from 'styles';
import { getFormConfig } from 'components/pages/Index/FormModals/formConfigs';
import DemoForm from 'components/pages/Index/FormModals/modalComponents/DemoForm';
import { globalHistory } from '@reach/router';
import _ from 'lodash';
import { breakpoint } from 'src/utils/mediaQueries';
import ConfirmModale from 'src/components/pages/ConfirmModale';
import Frame, { FrameContextConsumer } from 'react-frame-component';

const Container = styled.div`
  width: 50vw;
  ${breakpoint.down('md')`
    width: 100vw;
  `};
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled(Typography)`
  & h3 {
    font-size: 2em;
    text-align: center;
    //margin-top: 1em !important;
    //margin-bottom: 0 !important;
    margin: 0 5em 1em 5em !important;
    //margin-left: 5em !important;
    //margin-right: 5em !important;
    color: ${colors.purple};
  }
`;

const StyledFrame = styled(Frame)`
  width: 100%;
  height: 35em;
  ${breakpoint.down('sm')`
    height: 40em;
  `};
  border: none;
  padding: 0 1.5rem 1rem 1.5rem;
  overflow: hidden;
`;

const FormBlock = ({
  title: formTitle,
  langKey,
  confirmMessage,
  location,
  ...props
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { formHash, formComponent } = getFormConfig('DEMO');
  const { origin } = globalHistory.location;

  const clonedFormHash = _.cloneDeep(formHash);
  clonedFormHash['returnURL'] = `${origin}/${langKey}/${
    clonedFormHash['returnURL']
  }`;
  return (
    <Container>
      <Title>
        <div dangerouslySetInnerHTML={{ __html: formTitle }} />
      </Title>
      {isSubmitted || location.search === '?formSubmitted=true' ? (
        <ConfirmModale {...props} seo={props.seo} />
      ) : (
        <StyledFrame>
          <FrameContextConsumer>
            {frameContext => (
              <StyleSheetManager target={frameContext.document.head}>
                <DemoForm
                  formHash={clonedFormHash}
                  onSubmit={() => {
                    setTimeout(() => {
                      setIsSubmitted(true);
                    }, 500);
                  }}
                  isLoading={isLoading}
                />
              </StyleSheetManager>
            )}
          </FrameContextConsumer>
        </StyledFrame>
      )}
    </Container>
  );
};

export default FormBlock;
